import { Card, Column } from '@caldwell619/react-kanban'
import { StatusChamadaEnum } from 'models/atendimento/types'
import { Convenio, Invalid, Perfil } from 'models/types'

export enum TYPES {
  SET_KANBAN = '@@kanban/SET_KANBAN',
  SET_LOADING_KANBAN = '@@kanban/SET_LOADING_KANBAN',
  SET_OPTIONS_SELECT = '@@kanban/SET_OPTIONS_SELECT',
  SET_LOADING_SELECT = '@@kanban/SET_LOADING_SELECT',
  SET_FILTROS_FIELD = '@@kanban/SET_FILTROS_FIELD',
  SET_IS_OPEN_MODAL_KANBAN = '@@kanban/SET_IS_OPEN_MODAL_KANBAN',
  SET_INFORMACOES_MODAL_KANBAN = '@@kanban/SET_INFORMACOES_MODAL_KANBAN',
  SET_CONSULTOR_MODAL_KANBAN = '@@kanban/SET_CONSULTOR_MODAL_KANBAN',
  SET_CONSULTORES_MODAL_KANBAN = '@@kanban/SET_CONSULTORES_MODAL_KANBAN',
  SET_INFORMACOES_CARD_KANBAN_FIELD = '@@kanban/SET_INFORMACOES_CARD_KANBAN_FIELD',
  SET_ANOTACAO_CARD_KANBAN = '@@kanban/SET_ANOTACAO_CARD_KANBAN',
  SET_BIG_NUMBERS = '@@kanban/SET_BIG_NUMBERS',
  SET_IS_OPEN_MODAL_CADASTRO_CLIENTE = '@@kanban/SET_IS_OPEN_MODAL_CADASTRO_CLIENTE',
  SET_REGISTER_MODAL_CADASTRO_CLIENTE_FIELD = '@@kanban/SET_REGISTER_MODAL_CADASTRO_CLIENTE_FIELD',
  SET_REGISTER_MODAL_CADASTRO_CLIENTE = '@@kanban/SET_REGISTER_MODAL_CADASTRO_CLIENTE',
  CLEAN_REGISTER_MODAL_CADASTRO_CLIENTE = '@@kanban/CLEAN_REGISTER_MODAL_CADASTRO_CLIENTE',
  SET_INVALIDS_REGISTER_MODAL_CADASTRO_CLIENTE_FIELD = '@@kanban/SET_INVALIDS_REGISTER_MODAL_CADASTRO_CLIENTE_FIELD',
  CLEAN_INVALIDS_REGISTER_MODAL_CADASTRO_CLIENTE = '@@kanban/CLEAN_INVALIDS_REGISTER_MODAL_CADASTRO_CLIENTE',
  SET_IS_OPEN_MODAL_CPF = '@@kanban/SET_IS_OPEN_MODAL_CPF',
  SET_CPF_MODAL_CPF = '@@kanban/SET_CPF_MODAL_CPF',
  SET_IS_OPEN_MODAL_CONFIRMACAO = '@@kanban/SET_IS_OPEN_MODAL_CONFIRMACAO',
  SET_COORDENADOR = '@@kanban/SET_COORDENADOR',
  SET_MOVIMENTACAO_PENDENTE = '@@kanban/SET_MOVIMENTACAO_PENDENTE',
  SET_IS_OPEN_MODAL_MOTIVO = '@@kanban/SET_IS_OPEN_MODAL_MOTIVO',
  SET_MOTIVO_MOVIMENTACAO = '@@kanban/SET_MOTIVO_MOVIMENTACAO',
  CLEAN_MOTIVO_MOVIMENTACAO = '@@kanban/CLEAN_MOTIVO_MOVIMENTACAO',
  TOGGLE_CHATWOOT_MODAL = '@@atendimento/TOGGLE_CHATWOOT_MODAL',
  SET_INBOXES_CHATWOOT = '@@atendimento/SET_INBOXES_CHATWOOT',
  SET_AGENTES_CHATWOOT = '@@atendimento/SET_AGENTES_CHATWOOT',
  SET_INBOX_CHATWOOT_SELECTED = '@@atendimento/SET_INBOX_CHATWOOT_SELECTED',
  SET_AGENTE_CHATWOOT_SELECTED = '@@atendimento/SET_AGENTE_CHATWOOT_SELECTED',
  CLEAN_MODAL_CHATWOOT = '@@atendimento/CLEAN_MODAL_CHATWOOT',
  SET_IS_OPEN_MODAL_AGENDAMENTO = '@@kanban/SET_IS_OPEN_MODAL_AGENDAMENTO',
  SET_AGENDAMENTO = '@@kanban/SET_AGENDAMENTO',
  CLEAN_AGENDAMENTO = '@@kanban/CLEAN_AGENDAMENTO',
  SET_MODAL_AGENDAMENTO = '@@kanban/SET_MODAL_AGENDAMENTO',
  CLEAN_MODAL_AGENDAMENTO = '@@kanban/CLEAN_MODAL_AGENDAMENTO',
  SET_MODAL_DISCAGEM = '@@kanban/SET_MODAL_DISCAGEM',
  CLEAN_MODAL_DISCAGEM = '@@kanban/CLEAN_MODAL_DISCAGEM',

  GET_KANBAN_SAGA = '@@kanban/GET_KANBAN_SAGA',
  GET_CENTROS_CUSTO_SAGA = '@@kanban/GET_CENTROS_CUSTO_SAGA',
  GET_PIPELINES_SAGA = '@@kanban/GET_PIPELINES_SAGA',
  MOVIMENTAR_CARD_KANBAN_SAGA = '@@kanban/MOVIMENTAR_CARD_KANBAN_SAGA',
  GET_INFORMACOES_CARD_KANBAN_SAGA = '@@kanban/GET_INFORMACOES_CARD_KANBAN_SAGA',
  ATRIBUIR_CONSULTOR_CARD_KANBAN_SAGA = '@@kanban/ATRIBUIR_CONSULTOR_CARD_KANBAN_SAGA',
  GET_CONSULTORES_MODAL_KANBAN_SAGA = '@@kanban/GET_CONSULTORES_MODAL_KANBAN_SAGA',
  CRIAR_ANOTACAO_CARD_KANBAN_SAGA = '@@kanban/CRIAR_ANOTACAO_CARD_KANBAN_SAGA',
  GET_BIG_NUMBERS_SAGA = '@@kanban/GET_BIG_NUMBERS_SAGA',
  CADASTRAR_CLIENTE_SAGA = '@@kanban/CADASTRAR_CLIENTE_SAGA',
  ADICIONAR_CLIENTE_KANBAN_SAGA = '@@kanban/ADICIONAR_CLIENTE_KANBAN_SAGA',
  GET_CONVENIOS_SAGA = '@@kanban/GET_CONVENIOS_SAGA',
  GET_PERFIS_SAGA = '@@kanban/GET_PERFIS_SAGA',
  GET_PIPELINE_DEFAULT_SAGA = '@@kanban/GET_PIPELINE_DEFAULT_SAGA',
  VERIFICA_HIERARQUIA_E_DISPARA_GETS_SAGA = '@@kanban/VERIFICA_HIERARQUIA_E_DISPARA_GETS_SAGA',
  VERIFICAR_MOTIVO_MOVIMENTACAO_SAGA = '@@kanban/VERIFICAR_MOTIVO_MOVIMENTACAO_SAGA',
  EXECUTAR_MOVIMENTACAO_COM_MOTIVO_SAGA = '@@kanban/EXECUTAR_MOVIMENTACAO_COM_MOTIVO_SAGA',
  CRIAR_MOTIVO_MOVIMENTACAO_SAGA = '@@kanban/CRIAR_MOTIVO_MOVIMENTACAO_SAGA',
  GET_MOTIVOS_PERDA_SAGA = '@@kanban/GET_MOTIVOS_PERDA_SAGA',
  GET_INBOXES_CHATWOOT_SAGA = '@@kanban/GET_INBOXES_CHATWOOT_SAGA',
  GET_AGENTES_CHATWOOT_SAGA = '@@kanban/GET_AGENTES_CHATWOOT_SAGA',
  GET_AGENTE_SELECIONADO_CHATWOOT_SAGA = '@@kanban/GET_AGENTE_SELECIONADO_CHATWOOT_SAGA',
  ENVIAR_MENSAGEM_CHATWOOT_SAGA = '@@kanban/ENVIAR_MENSAGEM_CHATWOOT_SAGA',
  GET_TIPOS_AGENDAMENTO_SAGA = '@@kanban/GET_TIPOS_AGENDAMENTO_SAGA',
  CRIAR_AGENDAMENTO_SAGA = '@@kanban/CRIAR_AGENDAMENTO_SAGA',
  INITIALIZE_WEB_SOCKETS_CHANNEL_RETORNO_KANBAN_SAGA = '@@kanban/INITIALIZE_WEB_SOCKETS_CHANNEL_RETORNO_KANBAN_SAGA',
  DISCONNECT_WEB_SOCKETS_CHANNEL_RETORNO_KANBAN_SAGA = '@@kanban/DISCONNECT_WEB_SOCKETS_CHANNEL_RETORNO_KANBAN_SAGA',
  ATUALIZAR_INSCRICAO_PIPELINE_KANBAN_SAGA = '@@kanban/ATUALIZAR_INSCRICAO_PIPELINE_KANBAN_SAGA',
  DISCAR_CLIENTE_KANBAN_SAGA = '@@kanban/DISCAR_CLIENTE_KANBAN_SAGA'
}

export interface KANBAN {
  kanbanData: KanbanBoardWithEtapas<CardKanban>
  loadingKanban: boolean
  filtros: Filtros
  optionsSelect: OptionsSelect
  loadingSelect: LoadingOptionsSelect
  modalKanban: ModalKanban
  bigNumbers: BigNumbers
  modalCpf: ModalCpf
  modalCadastroCliente: ModalCadastroCliente
  modalConfirmacao: ModalConfirmacao
  coordenador: boolean
  movimentacaoPendente: {
    card: CardKanban
    from: { fromPosition: number; fromColumnId: string }
    to: { toPosition: number; toColumnId: string }
  } | null
  isOpenModalMotivo: boolean
  motivoMovimentacao: {
    observacao: string
    motivoId: string
    pipelineEtapaClienteId: string
  }
  inboxesChatwoot: SelectChatwoot[]
  agentesChatwoot: SelectChatwoot[]
  isModalChatwootOpen: boolean
  agenteChatwootSelected: string | null
  inboxChatwootSelected: string | null
  isOpenModalAgendamento: boolean
  agendamento: {
    pipelineEtapaClienteId: string
    dataAtendimento: string
    horario: string
    tipoAgendamentoId: string
    observacao: string
    ddd: string
    telefone: string
  }
  discagem: {
    isOpen: boolean
    numeroDiscado: string | null
    cpfDiscando: string | null
    statusChamada: StatusChamadaEnum
  }
}

export interface CardKanban extends Card {
  clienteId: string
  cpf: string
  telefone: string
  email: string
  value: number
  time: string
  borderColor: string
  perfis: string[]
  nomeConsultor: string | null
  consultorId: string | null
  situacao: 'Em dia' | 'Atrasado'
}

export interface ColumnWithEtapasPermitidas<
  TCard extends Card
> extends Column<TCard> {
  etapasPermitidas: {
    etapaId: string
    nome: string
  }[]
  modalMotivo?: boolean
}

export interface KanbanBoardWithEtapas<TCard extends Card> {
  nome: string
  descricao: string
  pipelineId: string
  centroCustoId: string
  site: boolean
  columns: ColumnWithEtapasPermitidas<TCard>[]
}

interface OptionsSelect {
  centrosCusto: Select[]
  pipelines: Select[]
  consultores: Select[]
  convenios: Convenio[]
  perfis: Perfil[]
  motivosPerda: Select[]
  tiposAgendamento: Select[]
}

type LoadingOptionsSelect = {
  [k in keyof OptionsSelect]: boolean
}

interface Select {
  id: string
  descricao: string
}

interface Filtros {
  centroCustoId: string | null
  pipelineId: string | null
  isArchived: boolean
}

export enum PerfilColor {
  SERVIDOR_PUBLICO_FEDERAL = '#FF5733',
  SERVIDOR_PUBLICO_MUNICIPAL = '#33FF57',
  CLT = '#3357FF',
  AUTONOMO = '#FF33A8',
  INSS = '#A833FF',
  SERVIDOR_PUBLICO_ESTADUAL = '#33FFF5',
  BOLSA_FAMILIA = '#F5FF33'
}

type PerfilKey = keyof typeof PerfilColor

export const perfilMap: Record<string, PerfilKey> = {
  INSS: 'INSS',
  CLT: 'CLT',
  AUTONOMO: 'AUTONOMO',
  'SERVIDOR PUBLICO MUNICIPAL': 'SERVIDOR_PUBLICO_MUNICIPAL',
  'SERVIDOR PUBLICO FEDERAL': 'SERVIDOR_PUBLICO_FEDERAL',
  'SERVIDOR PUBLICO ESTADUAL': 'SERVIDOR_PUBLICO_ESTADUAL',
  'BOLSA FAMILIA': 'BOLSA_FAMILIA'
}

interface ModalKanban {
  isOpen: boolean
  informacoes: InformacoesCardKanban
  consultor: {
    id: string
    nome: string
  }
  consultores: {
    id: string
    nome: string
  }[]
  anotacao: string
}

interface InformacoesCardKanban {
  pipelineEtapaClienteId: string
  clienteId: string
  nome: string
  cpf: string
  ddd: string | null
  numero: string | null
  telefoneId: string | null
  email: string | null
  ordem: string | null
  origem: string | null
  profissao: string | null
  valorOportunidade: number
  perfis: string[] | null
  dataCriacao: string
  dataMovimentacao: string | null
  consultorId: string
  nomeConsultor: string
  anotacoes:
    | {
        descricao: string
        dataCriacao: string
        nomeResponsavel: string
      }[]
    | null
  iteracoes:
    | {
        dataCriacao: string
        nomeResponsavel: string
        descricao: string
      }[]
    | null
  situacao: 'Em dia' | 'Atrasado' | null
}

interface BigNumbers {
  totalLeads: number
  totalLeadsAtraso: number
  totalNovosLeads: number
  totalTarefasConsultorHoje: number
}

interface ModalCpf {
  isOpen: boolean
  cpf: string
}

interface ModalCadastroCliente {
  isOpen: boolean
  register: RegisterCliente
  invalids: InvalidsRegisterCliente
}

interface RegisterCliente {
  nome: string
  cpf: string
  dataNascimento: string
  ddd: string
  telefone: string
  matricula: string
  perfilId: string | null
  convenioId?: string
  margem?: string
  margemCartao?: string
  indexTabCliente?: number
  numeroNit: string
}

type InvalidsRegisterCliente = {
  [K in keyof RegisterCliente]: Invalid
}

interface ModalConfirmacao {
  isOpen: boolean
}

export interface SelectChatwoot {
  id: string
  name: string
}

export interface MensagemChatwootDto {
  mensagem: string
  agentId: string
  inboxId: string
  cpfCliente: string
  numeroTelefone: string
}
